import React from 'react';
import { differenceInDays, format, isToday, isTomorrow } from 'date-fns';

interface Props {
  date: string | null;
}

export const DueDateLabel: React.FC<Props> = ({ date }) => {
  if (!date) return <span className="text-gray-600 text-xs">—</span>;

  const d = new Date(date);
  const now = new Date();
  const diff = differenceInDays(d, now);

  if (isToday(d)) return <span className="text-amber-400 text-xs font-medium">Today</span>;
  if (isTomorrow(d)) return <span className="text-yellow-400 text-xs font-medium">Tomorrow</span>;

  if (diff < 0) {
    const overdue = Math.abs(diff);
    const cls = overdue >= 4 ? 'text-red-400 bg-red-900/40 px-1.5 py-0.5 rounded' : 'text-red-400';
    return <span className={`text-xs font-medium ${cls}`}>{overdue}d overdue</span>;
  }

  if (diff <= 7) return <span className="text-yellow-400 text-xs">{diff}d</span>;
  if (diff <= 14) return <span className="text-gray-400 text-xs">{diff}d</span>;
  return <span className="text-gray-400 text-xs">{format(d, 'MMM d')}</span>;
};
